/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type InsightTranslationRequest = {
  target_language: InsightTranslationRequest.target_language;
};

export namespace InsightTranslationRequest {
  export enum target_language {
    KO = 'ko',
    EN = 'en',
    JA = 'ja',
  }
}
